import { Link } from 'react-router-dom';
import { useProfileStore } from '../../store/useUserStore';


const CourseCard = ({ course_id, name , concatDayArray, images, pricing_packages, saveCourseAndNavigate }: {
    course_id: number;
    name: string;
    concatDayArray: string[];
    images?: string[];
    pricing_packages?: {id:number, fee:number, count:number}[]
    saveCourseAndNavigate?: (course_branch_id: number) => void
}) => {
    const { setLastVisitedCourseId } = useProfileStore()

    const handleClickToSave = (e: React.MouseEvent) => {
        setLastVisitedCourseId(course_id.toString())
        if (saveCourseAndNavigate) {
            e.preventDefault() // prevent default <Link> behavior if handling manually
            saveCourseAndNavigate(course_id)
        }
    }

    const handleClickNoSave = () => {
        setLastVisitedCourseId(course_id.toString())
    }

    return (
    <div className="rounded-xl mb-8 shadow-course-card">
        <div className="text-center mb-1">
            <Link to={`/course/${course_id}`} onClick={saveCourseAndNavigate ? handleClickToSave : handleClickNoSave}>
                {images && images.length > 0 ? (
                    <img style={{ height: "10rem" }} className="img-fluid rounded-tl-lg rounded-tr-lg inline-block" alt="" src={images[0]}/>
                ):(
                    <img style={{ height: "10rem" }} className="img-fluid rounded-tl-lg rounded-tr-lg inline-block" alt="" src="/assets/img/products/product1.png"/>
                )}
            </Link>
        </div>
        <div className={`px-2 pb-2 ${concatDayArray?.length > 1 ? 'min-h-[4rem]' : ''}`}>
            <div className="flex justify-between items-center gap-2">
                <div className="font-semibold text-base line-clamp-2 overflow-hidden text-ellipsis truncate max-w-[70%]" title={name}>
                    <Link to={`/course/${course_id}`} onClick={saveCourseAndNavigate ? handleClickToSave : handleClickNoSave}>{name}</Link>
                </div>
                {pricing_packages && pricing_packages.length > 0 && (
                    <div className="text-[#00C39A] font-semibold text-base whitespace-nowrap">RM {pricing_packages[0].fee}</div>
                )}
            </div>
            <div className="flex flex-wrap gap-2 mt-2">
                {concatDayArray?.map((day: string, index: number) => (
                    <div key={index} className="px-2 py-1 rounded-lg bg-[#F1F1F1] text-gray-500 text-xs font-medium">
                    {day}
                    </div>
                ))}
            </div>
        </div>
    </div>
    )
}


export default CourseCard